import React, { useState } from "react";
import range from "ramda/src/range";

import { createContext } from "../../helpers/createContext";
import { normalize } from "../../helpers/normalize";

interface IPageTablePaginationContext {
  page: number;
  total: number;
  perPage: number;
  pages: number[];
  setPage: React.Dispatch<React.SetStateAction<number>>;
  setTotal: React.Dispatch<React.SetStateAction<number>>;
  setPerPage: React.Dispatch<React.SetStateAction<number>>;
  setPages: React.Dispatch<React.SetStateAction<number[]>>;
}

const [
  PageTablePaginationContext,
  usePageTablePaginationContext,
] = createContext<IPageTablePaginationContext>();

export const PageTablePaginationProvider: React.FC = (props) => {
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [pages, setPages] = useState<number[]>([1]);

  React.useEffect(() => {
    setPages(range(1, Math.ceil(total / perPage) + 1));
  }, [total, perPage]);

  const value = React.useMemo(
    () => ({
      page,
      pages,
      total,
      perPage,
      setPage,
      setPages,
      setTotal,
      setPerPage,
    }),
    [page, normalize(pages), total]
  );

  return <PageTablePaginationContext.Provider value={value} {...props} />;
};

export { usePageTablePaginationContext };
